<template>
  <div class="main_content">
    <div class="breadcrumbs" />
    <div class="settings">
      <config-bar class="settings_bar" />
      <v-sheet class="settings_main" :class="{ 'settings_main--fit': fit }">
        <router-view></router-view>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import ConfigBar from '@/views/settings/ConfigBar.vue';

export default {
  name: 'Settings',
  components: {
    ConfigBar,
  },
  computed: {
    fit() {
      return this.$route.name.startsWith('settings-notice');
    },
  },
};
</script>

<style lang="scss">
.settings {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
  &_main {
    flex-grow: 1;
    margin-left: 32px;
    width: calc(100% - 372px);
    height: 100%;
    min-width: 500px;
    // &.v-sheet {
    //   padding-bottom: 0;
    // }

    &--fit {
      height: fit-content;
    }
  }
  &_bar {
    display: flex;
    flex-direction: column;
    width: 340px;
    //max-height: 560px;
    max-height: 500px;
    flex-grow: 0;
    flex-shrink: 0;
  }
}
</style>
